interface CctvIconProps {
  className?: string;
}

/**
 * Inline bullet / outdoor-style CCTV surveillance camera icon (outlined).
 * Uses currentColor so it inherits Tailwind text-color classes like a Remix <i> icon.
 */
export default function CctvIcon({ className = '' }: CctvIconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      role="img"
    >
      {/* wall-mount bracket */}
      <path d="M20 10v5" />
      <path d="M20 12.5H13.8" />
      {/* bracket elbow down */}
      <path d="M13.8 12.5v2.3c0 .7-.4 1.2-1 1.2H11" />
      {/* bullet camera body */}
      <rect x="3" y="10" width="8" height="5" rx="2.3" />
      {/* lens ring */}
      <ellipse cx="3.8" cy="12.5" rx="1.2" ry="1.9" />
      {/* lens center dot */}
      <circle cx="3.8" cy="12.5" r=".6" />
      {/* IR LED indicators */}
      <path d="M5.8 11.2v.6" />
      <path d="M5.8 13.2v.6" />
      <path d="M7 11.2v.6" />
      <path d="M7 13.2v.6" />
      <path d="M8.2 11.2v.6" />
      <path d="M8.2 13.2v.6" />
    </svg>
  );
}